import { PureComponent } from "react";
import Date from "../../../../common/Date";
import { Moment } from "moment";
import moment from "moment";
import { Button } from "react-bootstrap";
import PieChartOilTypes from "./PieChartOilTypes";
import TreeMapBidders from "./TreeMapBidders";
import PriceHistoryChart from "./PriceHistoryChart";
import { getNumberDisplayValue } from "../../../../utils/format";
import { getNameForOil } from "../../../../common/Oils";
import { getStatistics } from "../../../../services/turgoil-api";

class RequesterStatistics extends PureComponent {
  state = {
    stats: null,
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    loading: false,
    error: null,
  };

  // Fetch statistics when button is clicked
  fetchStatistics = async () => {
    const { startDate, endDate } = this.state;
    const startDateVal = moment(startDate);
    const endDateVal = moment(endDate);

    if (!startDate || !endDate) {
      this.setState({ error: "Palun vali mõlemad kuupäevad" });
      return;
    } else if (!startDateVal.isValid()) {
      this.setState({ error: "Alguskuupäeva formaat ei ole korretkne" });
      return;
    } else if (!endDateVal.isValid()) {
      this.setState({ error: "Lõppkuupäeva formaat ei ole korretkne" });
      return;
    } else if (endDateVal.isBefore(startDateVal.startOf("day"))) {
      this.setState({
        error: "Lõppkuupäev peab olema hilisem kui alguskuupäev",
      });
      return;
    }

    this.setState({ loading: true, error: null });
    const queryParameters = {
      startDate: startDateVal.format("YYYY-MM-DD"),
      endDate: endDateVal.format("YYYY-MM-DD"),
    };

    getStatistics(queryParameters)
      .then((res) => {
        this.setState({
          loading: false,
          stats: res,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({ error: err.message, loading: false });
      });
  };

  handleStartDateChange = (date) => {
    let d = date;
    if (d instanceof moment) {
      (d as Moment).set({
        second: 0,
        millisecond: 0,
      });
      d = date.format("YYYY-MM-DD");
    }
    this.setState((prevState) => ({
      startDate: d,
      error: null,
    }));
  };

  handleEndDateChange = (date) => {
    let d = date;
    if (d instanceof moment) {
      (d as Moment).set({
        second: 0,
        millisecond: 0,
      });
      d = date.format("YYYY-MM-DD");
    }
    this.setState((prevState) => ({
      endDate: d,
      error: null,
    }));
  };

  componentDidMount() {
    this.fetchStatistics();
  }

  calculateAveragePriceByType = (data) => {
    const typeSums = {};
    const typeCounts = {};

    data.forEach(({ type, avgPricePerOilRequest }) => {
      if (!typeSums[type]) {
        typeSums[type] = 0;
        typeCounts[type] = 0;
      }
      typeSums[type] += parseFloat(avgPricePerOilRequest);
      typeCounts[type] += 1;
    });

    const averages = {};
    Object.keys(typeSums).forEach((type) => {
      averages[type] = getNumberDisplayValue(
        typeSums[type] / typeCounts[type],
        3,
      );
    });

    return averages;
  };

  render() {
    const { stats, startDate, endDate, loading, error } = this.state;
    const totalSumLitres =
      stats && stats.results
        ? stats.results.reduce((sum, item) => sum + (item.amount || 0), 0)
        : 0;
    const totalSumEur =
      stats && stats.results
        ? stats.results.reduce(
            (sum, item) =>
              sum + (item.amount * parseFloat(item.purchasePrice) || 0),
            0,
          )
        : 0;
    const averagePrices =
      stats && stats.results
        ? this.calculateAveragePriceByType(stats.results)
        : {};

    return (
      <>
        <div className="statistics__filters">
          <div className="statistics__filters__row">
            <div className="statistics__filters__row__input">
              <div className="statistics__filters__row__input__label">
                Alguskuupäev
              </div>
              <Date
                enablePastDates={true}
                onChange={this.handleStartDateChange}
                timeFormat={false}
                value={moment(startDate)}
              />
            </div>
            <div className="statistics__filters__row__input">
              <div className="statistics__filters__row__input__label">
                Lõppkuupäev
              </div>
              <Date
                enablePastDates={true}
                onChange={this.handleEndDateChange}
                timeFormat={false}
                value={moment(endDate)}
              />
            </div>
            <div className="statistics__filters__row__button">
              <Button
                type="button"
                onClick={this.fetchStatistics}
                className="px-5"
                variant="secondary"
                disabled={loading}
              >
                Visualiseeri
              </Button>
            </div>
          </div>
          <div
            className="statistics__filters__row"
            style={{ fontStyle: "italic", fontSize: "15px" }}
          >
            *Kõik kuvatavad hinnad on ilma käibemaksuta
          </div>
        </div>
        <div className="statistics__results">
          {/* Error Handling */}
          {error && <p style={{ color: "red" }}>{error}</p>}

          {/* Statistics Display */}
          {!error && stats && stats.results ? (
            <>
              <div className="statistics__results__row">
                <div className="statistics__results__container">
                  <div>Kokku ostetud kütust</div>
                  <div className="statistics__results__container__number">
                    {getNumberDisplayValue(totalSumLitres)} liitrit
                  </div>
                </div>
                <div className="statistics__results__container">
                  <div style={{ marginBottom: "3px" }}>Keskmine ühikuhind</div>
                  {Object.keys(averagePrices).length === 0 ? (
                    <div className="statistics__results__container__number">
                      -
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "2px",
                      }}
                    >
                      {Object.keys(averagePrices).map((type) => (
                        <div key={type} className="ringsSection">
                          <div className="ring" style={{ cursor: "auto" }}>
                            <span>{getNameForOil(type)}</span>
                          </div>
                          <div className="statistics__results__container__number">
                            {" "}
                            {averagePrices[type]} €/l
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="statistics__results__container">
                  <div>Kogukulu</div>
                  <div className="statistics__results__container__number">
                    {getNumberDisplayValue(totalSumEur, 2)} €
                  </div>
                </div>
                <div className="statistics__results__container">
                  <div>Keskmine maksetähtaeg</div>
                  <div className="statistics__results__container__number">
                    {getNumberDisplayValue(stats.avgPaymentTerm, 0)} päeva
                  </div>
                </div>
              </div>
              <div className="statistics__results__row">
                <div className="statistics__results__left_column">
                  <div className="statistics__results__container">
                    <div className="statistics__results__column">
                      <div className="statistics__results__container__title">
                        Hinnad ja kogused
                      </div>
                      <div>
                        <PriceHistoryChart data={stats.results} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="statistics__results__right_column">
                  <div className="statistics__results__container">
                    <div className="statistics__results__column">
                      <div className="statistics__results__container__title">
                        Kütuseliigid
                      </div>
                      <div>
                        {stats.results.length === 0 ? (
                          <div
                            style={{ fontSize: "14px", fontStyle: "italic" }}
                          >
                            {" "}
                            Andmed puuduvad
                          </div>
                        ) : (
                          <PieChartOilTypes data={stats.results} />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="statistics__results__container">
                    <div className="statistics__results__column">
                      <div className="statistics__results__container__title">
                        Tarnijate osakaal
                      </div>
                      {stats.results.length === 0 ? (
                        <div style={{ fontSize: "14px", fontStyle: "italic" }}>
                          {" "}
                          Andmed puuduvad
                        </div>
                      ) : (
                        <TreeMapBidders data={stats.results} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            !loading && !error && <p>No data available.</p>
          )}
        </div>
      </>
    );
  }
}

export default RequesterStatistics;
